const initialState = (translation) => {
    return {
      userConfig: {
      tooltip: {
        pointFormat: `<b>{point.y} ${translation}</b>`
      },
      plotOptions: {
        pie: {
          showInLegend: true,
          innerSize: "5%",
          dataLabels: {
            enabled: false,
            distance: -14,
            color: "white",
            style: {
              fontweight: "bold",
              fontsize: 25
            }
          }
        }
      }
    },
    loading: true,
    userPanels: []}
  };
  
  export default initialState;
  